/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombineDocumentsRequest
 */
export interface CombineDocumentsRequest {
    /**
     * The lead ID to retain (documents will be added here)
     * @type {string}
     * @memberof CombineDocumentsRequest
     */
    retain_lead_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CombineDocumentsRequest
     */
    combine_lead_ids: Array<string>;
    /**
     * Facility ID
     * @type {string}
     * @memberof CombineDocumentsRequest
     */
    facility_id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CombineDocumentsRequest
     */
    exclude_document_ids?: Array<string>;
}

/**
 * Check if a given object implements the CombineDocumentsRequest interface.
 */
export function instanceOfCombineDocumentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "retain_lead_id" in value;
    isInstance = isInstance && "combine_lead_ids" in value;
    isInstance = isInstance && "facility_id" in value;

    return isInstance;
}

export function CombineDocumentsRequestFromJSON(json: any): CombineDocumentsRequest {
    return CombineDocumentsRequestFromJSONTyped(json, false);
}

export function CombineDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineDocumentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'retain_lead_id': json['retain_lead_id'],
        'combine_lead_ids': json['combine_lead_ids'],
        'facility_id': json['facility_id'],
        'exclude_document_ids': !exists(json, 'exclude_document_ids') ? undefined : json['exclude_document_ids'],
    };
}

export function CombineDocumentsRequestToJSON(value?: CombineDocumentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'retain_lead_id': value.retain_lead_id,
        'combine_lead_ids': value.combine_lead_ids,
        'facility_id': value.facility_id,
        'exclude_document_ids': value.exclude_document_ids,
    };
}

